module.exports = __webpack_public_path__ + "static/media/greenchoice-bw.57ca02cf.jpg";